import { Paragraph } from "@sicredi/react";
import styles from "./styles.module.scss";

type CardResumeProps = {
  title: string;
  description: string;
};

export const CardResume: React.FC<CardResumeProps> = ({
  title,
  description,
}) => {
  return (
    <div className={styles.container}>
      <Paragraph size="small" weight="normal">
        {title}
      </Paragraph>
      <Paragraph weight="bold">{description}</Paragraph>
    </div>
  );
};
